import ArticlePage from 'components/pages/Article';

import { resolvify } from 'lib/promises';

import { getAds } from 'services/ads';
import { getArticleInfo, getLastArticleReviews } from 'services/article';
import { getCategoriesList } from 'services/category';
import { getLandingsList } from 'services/landing';
import { getStoresList } from 'services/store';

import APP from 'constants/app';
import LINKS from 'constants/links';

const Article = (props) => <ArticlePage {...props} />;

export const getServerSideProps = async ({ params: { articleSlug } }) => {
  try {
    const [
      article,
      reviews,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getArticleInfo({ articleSlug }),
      {
        fn: getLastArticleReviews(),
        fallback: getLastArticleReviews.fallback,
      },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    return {
      props: {
        article,
        reviews,
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    // Article doesn't exist
    return { redirect: { destination: LINKS[404], permanent: false } };
  }
};

export default Article;
